<template>
  <b-list-group>
    <b-list-group-item v-for="order in summary" :key="summary.fkorder" @click="clicked(order)" button>
      <div class="d-flex">
        <h6 class="mr-auto">{{ order.gli || '*NONE*' }} <span v-if="order.order && order.order.ship_country">({{ order.order.ship_country }})</span></h6>
        <div class="font-italic text-muted">
          {{ order.created | timediff }}
        </div>
      </div>
      <div class="d-flex">
        <div class="mr-auto">{{ order.quantity }} @ {{ order.price | money }}</div>
        <div>
          <order-pill v-if="order.order" :order="order.order"/>
          <b-badge v-else pill variant="danger">No Order</b-badge>
        </div>
      </div>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import OrderPill from "../order/order-pill.vue";

export default {
  name: "auction-sales-list",
  components: {OrderPill},
  props: {
    summary: Array
  },
  methods: {
    clicked(order) {
      window.open("/order/" + order.fkorder, "_blank")
    }
  }
}
</script>

<style scoped>

</style>